import { render, staticRenderFns } from "./invitedKioskList.vue?vue&type=template&id=0bc85a2c"
import script from "./invitedKioskList.vue?vue&type=script&lang=js"
export * from "./invitedKioskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports